// extracted by mini-css-extract-plugin
export default {"cards-list":"CardsList_cards-list__Qo0cH"};